<template>
    <el-col :xs="24" :md="12" :cols="12">
        <div id="colderecha">
            <template v-if="mode == 'selectorreceptor'">
                <div v-loading="loading">
                    <div class="clearfix">
                        <h2>Selección de destinatarios</h2>
                    </div>
                    <div class="opcionesselector" style="width: 360px; max-width: 400px">
                        <template v-if="working == 'documentos'">
                            <p :class="`receptor ${numSeleccion.empresas > 0 ? 'selected' : ''}`"
                                v-if="numReceptores.empresas > 0 && configEnvio.accion != 'firmar'"
                                @click="cambiarModo('selector'); selector = 'empresa';">
                                Empresas {{ numSeleccion.empresas > 0 ? "(" + numSeleccion.empresas + ")" : "" }}
                            </p>

                            <p :class="`receptor ${numSeleccion.areas > 0 ? 'selected' : ''}`"
                                v-if="numReceptores.areas > 0 && configEnvio.accion != 'firmar'"
                                @click="cambiarModo('selector'); selector = 'área';">
                                Áreas {{ numSeleccion.areas > 0 ? "(" + numSeleccion.areas + ")" : "" }}
                            </p>

                            <p :class="`receptor ${numSeleccion.centros > 0 ? 'selected' : ''}`"
                                v-if="numReceptores.centros > 0 && configEnvio.accion != 'firmar'"
                                @click="cambiarModo('selector'); selector = 'centro';">
                                Centros {{ numSeleccion.centros > 0 ? "(" + numSeleccion.centros + ")" : "" }}
                            </p>

                            <p :class="`receptor ${numSeleccion.departamentos > 0 ? 'selected' : ''}`"
                                @click="cambiarModo('selector'); selector = 'departamento'">Departamentos {{
                                    numSeleccion.departamentos > 0 ?
                                        '(' + numSeleccion.departamentos + ')' : '' }}</p>

                            <p v-if="configEnvio.accion == 'firmar' || (configEnvio.accion == 'almacenar' && configEnvio.entrada == 'archivo')"
                                :class="`receptor ${numSeleccion.empleados > 0 ? 'selected' : ''}`"
                                @click="cambiarModo('selector'); selector = 'empleado';">
                                Empleados {{ numSeleccion.empleados > 0 ? "(" + numSeleccion.empleados + ")" : "" }}
                            </p>
                            <template v-if="configEnvio.accion == 'almacenar' && configEnvio.entrada == 'archivo'">
                                <hr>
                                <p class="receptor" @click="configEnvio.autoemp = true; this.$router.push('/confirm')">
                                    Obtener empleados automáticamente
                                </p>
                                <p style="margin-top: 0px; color: #303133ad;">Esta opción seleccionará automáticamente
                                    cada receptor para cada archivo, según el DNI especificado en el nombre de éste.</p>
                            </template>
                        </template>
                        <template v-else>
                            <p v-if="configEnvio.accion == 'firmar'"
                                :class="`receptor warning ${numSeleccion.empleados > 0 ? 'selected' : ''}`"
                                @click="cambiarModo('selector'); selector = 'empleado';">
                                <i class="fa-solid fa-address-book"></i> Agenda {{ numSeleccion.empleados > 0 ? "(" +
                                    numSeleccion.empleados + ")" : "" }}
                            </p>

                            <p :class="`receptor warning`" @click="$router.push('/agenda')">
                                <font-awesome-icon :icon="['fas', 'user-plus']" />
                                Añadir contacto
                            </p>
                        </template>
                    </div>
                    <div v-if="working == 'documentos'"
                        style="display: flex; justify-content: space-between; margin: 20px; align-items: center;">
                        <div>
                            <a @click="cambiarModo('selector'); selector = 'selected';"
                                :style="`color: ${working == 'firmas' ? '#e6a23c' : '#0984e3'}; font-weight: bold; cursor: pointer`">Ver
                                selección</a>
                        </div>
                        <!-- <div>
                            <a @click="
                                sincronizarEmpleados();
                            selector = 'selected';
                            " style="color: #0984e3; font-weight: bold; cursor: pointer"><i
                                    :class="refrescando ? 'el-icon-loading' : 'el-icon-refresh'"></i>
                                Sincronizar empleados</a>
                        </div> -->
                    </div>
                </div>
                <div style="display: flex">
                    <el-button :type="working == 'firmas' ? 'warning' : 'primary'" icon="Back" @click="$router.go(-1)"
                        :disabled="leftDisabled" />
                    <el-button v-if="configEnvio.accion != 'firmar'" :type="working == 'firmas' ? 'warning' : 'primary'"
                        icon="Right" :disabled="rightDisabled" @click="
                            configEnvio.accion == 'almacenar' &&
                                configEnvio.entrada == 'archivo'
                                ? $router.push('/confirm')
                                : $router.push('/selectexpdate')
                            " />
                    <el-button v-if="configEnvio.accion == 'firmar'" :type="working == 'firmas' ? 'warning' : 'primary'"
                        icon="Right" :disabled="rightDisabled" @click="
                            configEnvio.accion == 'almacenar' &&
                                configEnvio.entrada == 'archivo'
                                ? $router.push('/confirm')
                                : $router.push('/selectposition')
                            " />
                </div>
            </template>
            <template v-if="mode == 'crearUsuario'">
                <div class="clearfix">
                    <h2>Crear nuevo contacto</h2>
                </div>
                <div style="width: 360px">
                    <b>Nombre</b>
                    <el-input style="margin-bottom: 20px;" v-model="nuevoUsuario.nombre" size="large"></el-input>
                    <b>Primer apellido</b>
                    <el-input style="margin-bottom: 20px;" v-model="nuevoUsuario.apellido1" size="large"></el-input>
                    <b>Segundo apellido</b>
                    <el-input style="margin-bottom: 20px;" v-model="nuevoUsuario.apellido2" size="large"></el-input>
                    <b>Email</b>
                    <el-input style="margin-bottom: 20px;" v-model="nuevoUsuario.email" size="large"></el-input>
                    <b>Número de móvil</b>
                    <el-input style="margin-bottom: 20px;" v-model="nuevoUsuario.telefono" size="large"></el-input>
                    <b>Número de DNI/NIE (con letra)</b>
                    <el-input style="margin-bottom: 20px;" v-model="nuevoUsuario.dni" size="large"></el-input>
                    <b>Cargo</b>
                    <el-input style="margin-bottom: 20px;" v-model="nuevoUsuario.cargo" size="large"></el-input>
                    <el-button @click="anadirExterno()" style="margin-top: 20px; width: 100%"
                        type="warning">Guardar</el-button>
                </div>
                <div
                    style="display: flex; justify-content: space-between; margin: 20px; align-items: center; width: 400px;">
                    <div></div>
                    <div>
                        <el-button :type="working == 'firmas' ? 'warning' : 'primary'" icon="Back"
                            @click=" cambiarModo('selectorreceptor'); busqueda = '';" />
                    </div>
                </div>
            </template>
            <template v-if="mode == 'selector'">
                <div class="clearfix">
                    <h2 v-if="selector == 'selected'">Ver selección</h2>
                    <h2 v-else>Selección de destinatarios</h2>
                </div>
                <div class="contenedorbusqueda">
                    <el-input style="width: 100%" type="text" v-model="busqueda"
                        placeholder="Escribe para buscar"></el-input>
                </div>
                <div name="fade" class="contenedorreceptores">
                    <p v-if="selector == 'selected'" class="receptor warning" key="vaciarselector"
                        @click="listReset(); actualizarReceptores();">
                        <font-awesome-icon icon="fa-solid fa-trash" /> Vaciar selección
                    </p>
                    <template v-if="working == 'documentos'">
                        <p v-for="receptor in filteredReceptores" :key="receptor.id + receptor.tipo"
                            :class="`receptor ${working == 'firmas' ? 'warning' : ''} ${receptor.selected ? 'selected' : ''} ${receptor.disabled ? 'disabled' : ''}`"
                            @click="!receptor.disabled ? (receptor.selected = !receptor.selected) : ''; actualizarReceptores(); actualizarLista(receptor);">
                            {{ receptor.nombre }}
                            <small v-if="receptor.nombredep"><br />{{ receptor.nombredep }}</small>
                            <small v-if="receptor.cargo"><br />{{ receptor.cargo }}</small>
                        </p>
                        <p v-for="receptor in filteredReceptoresSeleccion" :key="receptor.id + receptor.tipo" :class="`receptor ${receptor.selected ? 'selected' : ''} ${receptor.disabled ? 'disabled' : ''
                            }`"
                            @click="!receptor.disabled ? (receptor.selected = !receptor.selected) : ''; actualizarReceptores(); actualizarLista(receptor);">
                            {{ receptor.nombre }}
                            <small v-if="receptor.nombredep"><br />{{ receptor.nombredep }}</small>
                        </p>
                    </template>
                    <template v-else>
                        <p v-for="(receptor, index) in filteredReceptores" :key="receptor.id + receptor.tipo"
                            :class="`receptor ${working == 'firmas' ? 'warning' : ''} ${receptor.selected ? 'selected' : ''} ${receptor.disabled ? 'disabled' : ''}`"
                            @click="seleccionarReceptor(receptor)">
                            <span v-if="receptor.selected">{{ index + 1 }}. </span> {{ receptor.nombre }}
                            <small v-if="receptor.nombredep"><br />{{ receptor.nombredep }}</small>
                            <small v-if="receptor.cargo"><br />{{ receptor.cargo }}</small>
                        </p>
                    </template>
                </div>
                <div
                    style="display: flex; justify-content: space-between; margin: 20px; align-items: center; width: 400px;">
                    <div>
                        <a v-if="selector == 'empresa'" @click="seleccionarTodo(selector)"
                            style="color: #0984e3; font-weight: bold; cursor: pointer">Seleccionar todas</a>
                    </div>
                    <div>
                        <el-button :type="working == 'firmas' ? 'warning' : 'primary'" icon="Back"
                            @click="cambiarModo('selectorreceptor'); busqueda = '';" />
                    </div>
                </div>
            </template>
        </div>
    </el-col>
</template>

<script>
import { ElNotification } from "element-plus";
// import { curl } from '@/api.js';
import { mapMutations } from "vuex";
import { mapState } from "vuex";

export default {
    name: "SelectorReceptores",
    components: {},
    watch: {
        mode() {
            this.nuevoUsuario = {
                nombre: "",
                apellido1: "",
                apellido2: "",
                telefono: "",
                email: "",
                dni: "",
                cargo: ""
            };
        },
    },
    data() {
        return {
            loading: false,
            paso: 1,
            tipoDocumento: "",
            file: [],
            acciones: {},
            mode: "selectorreceptor",
            numSeleccion: {
                empresas: 0,
                areas: 0,
                centros: 0,
                departamentos: 0,
                empleados: 0,
            },
            selector: "",
            busqueda: "",
            receptoresLocal: [],
            refrescando: false,
            nuevoUsuario: {
                nombre: "",
                apellido1: "",
                apellido2: "",
                telefono: "",
                email: "",
                dni: "",
            },
            working: process.env.VUE_APP_WORKING
        };
    },
    mounted() {
        this.actualizarReceptores();
        this.configEnvio.paginaActual = "selectreceivers";
        this.configEnvio.autoemp = false;
    },
    computed: {
        ...mapState([
            "datosemp",
            "receptores",
            "configEnvio",
            "numReceptores",
            "documentos",
        ]),
        leftDisabled() {
            return false;
        },
        rightDisabled() {
            if (
                this.numSeleccion.empresas ||
                this.numSeleccion.areas ||
                this.numSeleccion.centros ||
                this.numSeleccion.departamentos ||
                this.numSeleccion.empleados
            ) {
                return false;
            }
            return true;
        },
        filteredReceptores() {
            return this.receptores.filter(
                (receptor) =>
                    receptor.tipo == this.selector &&
                    (receptor.nombre.toLowerCase().includes(this.busqueda.toLowerCase()) || (receptor.cargo && receptor.cargo.toLowerCase().includes(this.busqueda.toLowerCase())))
            );
        },
        filteredReceptoresSeleccion() {
            return this.receptores.filter(
                (receptor) =>
                    this.selector == "selected" &&
                    receptor.selected &&
                    (receptor.nombre.toLowerCase().includes(this.busqueda.toLowerCase()) || (receptor.cargo && receptor.cargo.toLowerCase().includes(this.busqueda.toLowerCase())))
            );
        },
        filteredEmpleados() {
            return this.receptores.filter(
                (receptor) =>
                    receptor.tipo == "empleado" &&
                    (receptor.selected || receptor.disabled)
            );
        },
    },
    methods: {
        ...mapMutations(["setDatosemp", "setReceptores"]),
        async anadirExterno() {
            if (
                this.nuevoUsuario.nombre == "" ||
                this.nuevoUsuario.apellido1 == "" ||
                this.nuevoUsuario.apellido2 == "" ||
                this.nuevoUsuario.telefono == "" ||
                this.nuevoUsuario.email == "" ||
                this.nuevoUsuario.dni == "" ||
                this.nuevoUsuario.cargo == ""
            ) {
                ElNotification({
                    title: "Error",
                    message: "Por favor, rellena todos los datos",
                    type: "error",
                });
                return;
            } else {
                let regex = /^[67][0-9]{8}$/;
                if (!regex.test(this.nuevoUsuario.telefono)) {
                    ElNotification({
                        title: "Error",
                        message: "El formato del teléfono introducido no es correcto",
                        type: "error",
                    });
                    return;
                }
                regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
                if (!regex.test(this.nuevoUsuario.email)) {
                    ElNotification({
                        title: "Error",
                        message: "El email introducido no es correcto",
                        type: "error",
                    });
                    return;
                }
                if (
                    !/^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKE]$/i.test(this.nuevoUsuario.dni) &&
                    !/^[XYZ][0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKE]$/i.test(
                        this.nuevoUsuario.dni
                    )
                ) {
                    ElNotification({
                        title: "Error",
                        message: "El DNI/NIE introducido no es válido",
                        type: "error",
                    });
                    return;
                }
                this.nuevoUsuario.nombre = `${this.nuevoUsuario.nombre} ${this.nuevoUsuario.apellido1} ${this.nuevoUsuario.apellido2}`;
                this.nuevoUsuario.name = this.nuevoUsuario.nombre;
                this.nuevoUsuario.centro_id = 0;
                this.nuevoUsuario.disabled = false;
                this.nuevoUsuario.empresa = "FIRMANTE EXTERNO";
                this.nuevoUsuario.estado = null;
                this.nuevoUsuario.nombrecentro = "FIRMANTE EXTERNO";
                this.nuevoUsuario.selected = true;
                this.nuevoUsuario.tipo = "empleado";
                this.nuevoUsuario.externo = true;
                this.nuevoUsuario.user_mail = this.datosemp.mail;
                let resp = await fetch(process.env.VUE_APP_PORTAL + ':8003/api/crearContacto', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(this.nuevoUsuario)
                });
                if (resp.status == 200) {
                    this.receptores.push(this.nuevoUsuario);
                    this.actualizarReceptores();
                    ElNotification({
                        title: "¡Bien!",
                        message: "El contacto se ha añadido correctamente",
                        type: "success",
                    });
                    this.cambiarModo("selectorreceptor");
                } else {
                    ElNotification({
                        title: "Oops",
                        message: "Ha ocurrido un error añadiendo el nuevo contacto",
                        type: "success",
                    });
                }
            }
        },
        cambiarModo(modo) {
            this.loading = true;
            this.mode = "none";
            setTimeout(() => {
                this.mode = modo;
                this.loading = false;
            }, 400);
        },
        actualizarReceptores() {
            // Definir el orden de los tipos
            var ordenTipos = [
                "empresa",
                "área",
                "centro",
                "departamento",
                "empleado",
            ];
            // Ordenar el array
            // this.receptores.sort(function (a, b) {
            //   return a.localeCompare(b);
            // })
            if (this.working == 'documentos') {
                this.receptores.sort(function (a, b) {
                    if (a.selected && !b.selected) {
                        return -1; // a viene antes que b (a es selected y b no)
                    } else if (!a.selected && b.selected) {
                        return 1; // b viene antes que a (b es selected y a no)
                    } else if (a.disabled && !b.disabled) {
                        return 1; // b viene antes que a (a es disabled y b no)
                    } else if (!a.disabled && b.disabled) {
                        return -1; // a viene antes que b (b es disabled y a no)
                    } else {
                        // Si tienen el mismo valor para "selected" y "disabled", ordenar por "tipo" y luego por "id"
                        var tipoA = ordenTipos.indexOf(a.tipo);
                        var tipoB = ordenTipos.indexOf(b.tipo);
                        if (tipoA !== tipoB) {
                            return tipoA - tipoB; // Ordenar por "tipo" según el orden definido en "ordenTipos"
                        } else if (a.nombre != null && b.nombre != null) {
                            return a.nombre.localeCompare(b.nombre); // Ordenar por "id" en orden ascendente
                        }
                    }
                });
            }
            this.uploadData = {
                receptores: JSON.stringify(this.receptores),
            };
            this.numSeleccion = {
                empresas: 0,
                areas: 0,
                centros: 0,
                departamentos: 0,
                empleados: 0,
                total: 0,
            };
            let receptores = this.receptores.filter(function (receptor) {
                return receptor.selected;
            });
            receptores.forEach((receptor) => {
                switch (receptor.tipo) {
                    case "empresa":
                        this.numSeleccion.empresas++;
                        break;
                    case "área":
                        this.numSeleccion.areas++;
                        break;
                    case "centro":
                        this.numSeleccion.centros++;
                        break;
                    case "departamento":
                        this.numSeleccion.departamentos++;
                        break;
                    case "empleado":
                        this.numSeleccion.empleados++;
                        break;
                }
                this.documentos.forEach((doc) => {
                    doc.firmantes = [];
                });
            });
            this.numSeleccion.total =
                this.numSeleccion.empresas +
                this.numSeleccion.areas +
                this.numSeleccion.centros +
                this.numSeleccion.departamentos +
                this.numSeleccion.empleados;
        },
        actualizarLista(receptor) {
            let areas = this.receptores.filter(function (area) {
                return area.tipo == "área" && area.empresa_id == receptor.id;
            });
            let centros = this.receptores.filter(function (centro) {
                return centro.tipo == "centro" && centro.area_id == receptor.id;
            });
            let empleados = this.receptores.filter(function (empleado) {
                return empleado.tipo == "empleado" && empleado.centro_id == receptor.id;
            });
            let empleadosdpt = this.receptores.filter(function (empleado) {
                return empleado.tipo == "empleado" && empleado.departamento_id == receptor.id;
            });
            switch (receptor.tipo) {
                case "empresa":
                    areas.forEach((area) => {
                        area.selected = false;
                        area.disabled = receptor.selected;
                        this.actualizarLista(area);
                    });
                    break;
                case "área":
                    centros.forEach((centro) => {
                        centro.selected = false;
                        centro.disabled = receptor.disabled - receptor.selected;
                        this.actualizarLista(centro);
                    });
                    break;
                case "centro":
                    empleados.forEach((empleado) => {
                        empleado.selected = false;
                        empleado.disabled = receptor.disabled - receptor.selected;
                    });
                    break;
                case "departamento":
                    empleadosdpt.forEach((empleado) => {
                        if (empleado.departamento_id == receptor.id) {
                            empleado.selected = false;
                            empleado.disabled = receptor.disabled - receptor.selected;
                        }
                    });
                    break;
            }
            this.actualizarReceptores();
        },
        listReset() {
            this.receptores.forEach((receptor) => {
                receptor.selected = false;
                receptor.disabled = false;
            });
            this.actualizarReceptores();
            this.file = [];
            this.contenidoEditor = "";
            this.tipoDocumento = "";
            this.tipoPublicacion = "";
            this.pub_titulo = "";
            this.documentos = [];
            this.emailNotificacion = false;
        },
        seleccionarTodo(tipo) {
            this.receptores.forEach((receptor) => {
                if (receptor.tipo == tipo) {
                    receptor.selected = true;
                    this.actualizarReceptores();
                    this.actualizarLista(receptor);
                }
            });
        },
        seleccionarReceptor(receptor) {
            let indexreceptor = this.receptores.indexOf(receptor);
            if (!receptor.selected) {
                !receptor.disabled ? (receptor.selected = !receptor.selected) : '';
                let receptorposicion = { ...this.receptores[this.numSeleccion.empleados] };
                this.receptores[this.numSeleccion.empleados] = { ...receptor }
                this.receptores[indexreceptor] = { ...receptorposicion }
                this.actualizarReceptores();
                this.actualizarLista(receptor);
            } else {
                receptor.selected = !receptor.selected
                let copia = { ...this.receptores[indexreceptor] }
                this.receptores.splice(indexreceptor, 1)
                this.receptores.push(copia);
                this.actualizarReceptores();
                this.actualizarLista(receptor);
            }

        }
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#colderecha {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-height: calc(100vh - 20px);
    overflow: auto;
    padding: 10px 0px;

    @media (max-width: 400px) {
        height: 80vh;
    }

    .opcionesselector {
        margin: 50px 0 50px 0;

        ul {
            padding: 10px;
            list-style: none;
            display: flex;
            flex-wrap: wrap;
            gap: 10px;
            align-items: center;
            justify-content: space-between;
            color: #0000007a;

            li {
                min-width: 47%;
                aspect-ratio: 2;
                border-radius: 8px;
                background-color: rgb(236, 253, 237);
                border: 1px solid rgb(216, 250, 216);
                color: #409b4f;
                position: relative;
                overflow: hidden;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;

                &:nth-last-child(2) {
                    background-color: rgb(253, 253, 236);
                    border: 1px solid rgb(248, 250, 216);
                    color: #9b7b40;

                    &.expanded {
                        width: 100%;
                        aspect-ratio: 4;
                    }
                }

                &:last-child {
                    width: 100%;
                    background-color: rgb(236, 239, 253);
                    border: 1px solid rgb(216, 219, 250);
                    color: #40469b;
                    aspect-ratio: 4;
                }

                @media (min-width: 770px) {
                    width: 48%;
                }
            }
        }

        p {
            position: relative;
            z-index: 2;
            // font-size: 1.5rem;
            // margin: 0px;
        }
    }

    .receptor {
        border: 2px solid #0984e3;
        padding: 15px;
        border-radius: 10px;
        color: #0984e3;
        background-color: #0985e31f;
        font-weight: bold;
        margin: 10px;
        transition: 0.5s;
        cursor: pointer;

        &:hover {
            background-color: #6dff4005;
        }

        &.selection {
            border: 2px solid #399148;
            color: #ffffff;
            background-color: #409b4f;

            &:hover {
                background-color: #52c465;
            }
        }

        &.selected {
            border: 2px solid #0984e3;
            color: #ffffff;
            background-color: #0984e3;

            &:hover {
                background-color: #0985e3cb;
            }
        }

        &.disabled {
            border: 2px solid #0985e31e;
            color: #0984e3;
            background-color: #0985e30e;
            cursor: not-allowed;
        }

        &.warning {
            border: 2px solid #e6a23c;
            color: #ffffff;
            background-color: #ffeeaf47;
            color: #e6a23c;

            &.selected {
                background-color: #e6a23c;
                color: white;
            }

            &:hover {
                background-color: #e6a23c;
                color: white;
            }
        }
    }

    .contenedorreceptores {
        @media (min-width: 480px) {
            width: 400px;
        }

        height: 50vh;
        overflow-y: auto;
    }

    .contenedorbusqueda {
        @media (min-width: 480px) {
            width: 400px;
        }

        margin-bottom: 10px;
        overflow-y: auto;
    }
}
</style>